/**
 * Human-readable label for a DPAT comment row's stored `userRole`
 * (CMS may use underscores or spaces).
 */
const ROLE_ALIASES = {
  DPAT_TECHNICAL_TEAM: "DPAT Technical Team",
  DTT: "DPAT Technical Team",
  DPAT_QUALITY_ASSURANCE: "DPAT Quality Assurance",
  DQA: "DPAT Quality Assurance",
  DPAT_DISTRICT_USERS: "DPAT District Users",
  DPAT_PETITION_COMMITTEE: "DPAT Complaints Resolution Committee",
  SUPER_ADMIN: "Superuser",
};

export function normalizeDpatCommentRoleKey(role) {
  if (role == null || role === "") return "";
  return String(role).trim().replace(/\s+/g, "_").toUpperCase();
}

export function isDpatQualityAssuranceCommentRole(role) {
  const key = normalizeDpatCommentRoleKey(role);
  return key === "DQA" || key === "DPAT_QUALITY_ASSURANCE" || key === "QUALITY_ASSURANCE";
}

export function formatDpatCommentUserRole(role) {
  const key = normalizeDpatCommentRoleKey(role);
  if (!key) return "Role not recorded";
  if (ROLE_ALIASES[key]) return ROLE_ALIASES[key];
  return key
    .split("_")
    .filter(Boolean)
    .map((w) => w.charAt(0) + w.slice(1).toLowerCase())
    .join(" ");
}
